const style = {
  textColor: {
    color: "#6258de",
    borderColor: "#6258de",
  },
};

export default style;
